import React, {Component} from 'react';
import {Icon, Input, message, Tag, Tooltip} from 'antd';
import {queryRelateTagCustom, queryTagDefault} from '@api/incubator/customBase';
import MyTag from './MyTag';

class CardBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultTags: [],
      tags: [],
      inputVisible: false,
      inputValue: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getTagsDefault();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customInfo.tags) {
      this.setState({
        tags: nextProps.customInfo.tags,
      });
    }
  }

  getTagsDefault = () => {
    queryTagDefault().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          defaultTags: res.data,
        });
      }
    });
  };

  relateTagCustom = (defaultTags, tags) => {
    const params = {
      customUuid: this.props.params.customUuid,
      tags: [...defaultTags.filter(item => item.checked), ...tags],
    };
    queryRelateTagCustom(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
      }
    });
  };

  handleClose = removedTag => {
    const { defaultTags } = this.state;
    let { tags } = this.state;
    tags = tags.filter(tag => tag.name !== removedTag);
    this.setState({ tags });
    this.relateTagCustom(defaultTags, tags);
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue, defaultTags } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, { name: inputValue }];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    });
    this.relateTagCustom(defaultTags, tags);
  };

  saveInputRef = input => {
    this.input = input;
  };

  handleChange = uuid => {
    const { defaultTags, tags } = this.state;
    defaultTags.forEach(item => {
      if (item.uuid === uuid) {
        item.checked = !item.checked;
      }
    });
    this.setState({
      defaultTags,
    });
    this.relateTagCustom(defaultTags, tags);
  };

  render() {
    const { defaultTags, tags, inputVisible, inputValue } = this.state;
    return (
      <div>
        <span>
          {defaultTags.map(item => (
            <MyTag
              handleChange={this.handleChange}
              key={item.uuid}
              uuid={item.uuid}
              checked={item.checked}
            >
              {item.name}
            </MyTag>
          ))}
          {tags.map((tag, index) => {
            const isLongTag = tag.name.length > 20;
            const tagElem = (
              <Tag key={tag.name} closable onClose={() => this.handleClose(tag.name)}>
                {isLongTag ? `${tag.name.slice(0, 20)}...` : tag.name}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag.name} key={tag.name}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          {inputVisible && (
            <Input
              ref={this.saveInputRef}
              type="text"
              size="small"
              style={{ width: 78 }}
              value={inputValue}
              onChange={this.handleInputChange}
              onBlur={this.handleInputConfirm}
              onPressEnter={this.handleInputConfirm}
            />
          )}
          {!inputVisible && (
            <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
              <Icon type="plus" /> New Tag
            </Tag>
          )}
        </span>
      </div>
    );
  }
}

export default CardBase;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/CustomTag.js